<template>
  <div>
    <v-icon @click="mostrarDialogo = true" color="amber accent-4"
      >mdi-pencil</v-icon
    >
    <v-dialog v-model="mostrarDialogo" max-width="600px">
      <v-card :loading="cargando">
        <v-card-title>
          <h3>Editar Usuario:</h3>
          <u class="mx-3"> {{ infoUsuario.USUARIO }} </u>
        </v-card-title>

        <v-spacer />
        <!-- Espaciador -->

        <v-card-text>
          <v-form class="px-3 my-3">
            <v-text-field
              label="Usuario"
              v-model="usuario"
              readonly
              filled
              required
              :rules="[(v) => !!v || 'Ingresa tu usario']"
            />
            <v-text-field
              label="Nombre/s"
              v-model="nombre"
              required
              :rules="reglas"
            />
            <v-text-field
              label="Apellido Paterno"
              v-model="paterno"
              required
              :rules="reglas"
            />
            <v-text-field
              label="Apellido Materno"
              v-model="materno"
              required
              :rules="reglas"
            />
            <v-text-field
              label="Correo"
              v-model="correo"
              required
              :rules="emailRules"
            />
            <label class="d-flex justify-center text-body-1 text--primary"
              >Editar Roles</label
            >
            <v-alert v-if="cargando" type="info" class="d-flex justify-center">
              <span class="text--white">Cargando Roles...</span>
            </v-alert>
            <v-row class="d-flex justify-space-around">
              <v-col
                cols="12"
                sm="6"
                md="6"
                v-for="rol in rolesCheckboxes"
                :key="rol.ROL_ID"
              >
                <v-checkbox
                  v-model="rolesUsuario"
                  :label="rol.DESCRIPCION"
                  :value="rol.ROL_ID"
                />
              </v-col>
            </v-row>
            <v-text-field
              label="Contraseña"
              v-model="contrasena1"
              type="password"
              required
            />
            <v-text-field
              label="Contraseña"
              v-model="contrasena2"
              type="password"
              required              
            />

            <v-alert v-if="error" class="red lighten-3 d-flex justify-center">
              <span class="text--white">Las contraseñas no coinciden.</span>
            </v-alert>

            <div class="d-flex justify-center">
              <v-btn
                class="mx-2 mt-3"
                dark
                @click="mostrarDialogo = !mostrarDialogo"
              >
                Cancelar
              </v-btn>
              <v-btn
                class="success mx-2 mt-3"
                @click="btnEditarUsuario"
                :disabled="!Valido"
                ><span> Guardar Cambios </span></v-btn
              >
            </div>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  // Valor pasado por el componente padre:
  //  en este caso infoUsuario viene de views/Usuarios.vue
  props: ["infoUsuario"],

  data() {
    return {
      mostrarDialogo: false,
      Valido: true,
      error: false,
      cargando: false,

      usuario: "" + this.infoUsuario.USUARIO,
      nombre: "" + this.infoUsuario.NOMBRE,
      paterno: "" + this.infoUsuario.APELLIDO_P,
      materno: "" + this.infoUsuario.APELLIDO_M,
      rolesCheckboxes: [],
      rolesUsuario: [],
      contrasena1: "",
      contrasena2: "",
      correo:"" + this.infoUsuario.CORREO,

      reglas: [(v) => !!v || "Campo Obligatorio"],

      emailRules: [ v => /.+@.+/.test(v) || 'Invalid Email address' ]

    };
  },

  computed: {
    ...mapGetters(["getUsuario", "getURLAPI", "getFechaActual"]),
  },

  methods: {
    btnEditarUsuario() {
      if (this.rolesUsuario.length > 0) {
        // if (this.contrasena1 == this.contrasena2) {
          const datosUsuario = {
            NOMBRE: this.nombre.toUpperCase(),
            APELLIDO_P: this.paterno.toUpperCase(),
            APELLIDO_M: this.materno.toUpperCase(),
            USUARIO: this.usuario.toUpperCase(),
            CORREO: this.correo,
            // PASS: this.contrasena1,
            ESTATUS: this.infoUsuario.ESTATUS,
            TIPO_ID: this.infoUsuario.TIPO_ID,
            USUARIO_CREADOR: this.infoUsuario.USUARIO_CREADOR,
            FECHA_HORA_CREACION: this.infoUsuario.FECHA_HORA_CREACION,
            USUARIO_MODIFICACION: this.getUsuario,
            // 'USUARIO_MODIFICACION':     "admin",
            FECHA_HORA_MODIFICACION: this.getFechaActual,
            ROL_ID: this.rolesUsuario,
          };

          if (this.contrasena1 != "" || this.contrasena2 != "") 
          {
            if (this.contrasena1 == this.contrasena2) 
            {
              datosUsuario['PASS'] = this.contrasena1;  
            }
            else 
            {
              this.error = true;
              console.log("sali del metodo");

              return;
            } 
          }

          console.log("segui el metodo");
          // 192.168.1.90:3000/User/update/id
          axios
            .put(
              `${this.getURLAPI}/Usuarios/updateUser/${this.infoUsuario.USUARIO_ID}`,
              datosUsuario
            )
            .then((res) => {
              // '$emit' Ejecuta el metodo declarado en el componente 'padre'
              // en este caso el padre es 'Usuarios.vue'
              this.$emit("actualizarTabla");
              this.$root.vtoast.show({
                message: res.data.MSG,
                color:
                  res.data.STATUS == "OK" ? "success darken-2" : "red darken-2",
                timer: 10000,
                icon:
                  res.data.STATUS == "OK"
                    ? "mdi-check"
                    : "mdi-alert-circle-outline",
              });
              this.mostrarDialogo = false;
            })
            .catch((err) => {
              console.log(err.message);
            });
        // } else {
        //   this.error = true;
        // }
      } else {
        this.$root.vtoast.show({
          message: "Se necesita asignar al menos un 'Rol' al usuario",
          color: "black",
          timer: 5000,
          icon: "mdi-alert-circle-outline",
        });
      }
    },

    getRolesUsuario() {
      let datosForm = new FormData();
      datosForm.append("USUARIO_ID", this.infoUsuario.USUARIO_ID);
      axios
        .post(`${this.getURLAPI}/Usuarios/getRolesUsuario`, datosForm)
        .then(({ data }) => {
          for (const rol of data) {
            this.rolesUsuario.push(rol.ROL_ID);
          }
          this.cargando = false;
        })
        .catch(() => {
          this.cargando = false;
        });
    },
  },

  async created() {
    this.cargando = true;
    this.error = false;
    this.rolesCheckboxes = (
      await axios.get(`${this.getURLAPI}/Show/allRol`)
    ).data;
    this.getRolesUsuario();
  },
};
</script>

<style></style>
